//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div
    class="go_checkmark"
    :style="{ background: store.state.Style.themeColor }"
  >
    <div class="go_check"></div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { defineProps, onBeforeUnmount, inject } from "vue";
const props = defineProps(["analyticsEvent"]);
const api = inject("api");
const store = useStore();

onBeforeUnmount(function () {
  if (!props.analyticsEvent) {
    return;
  }
  api.analytics.log(props.analyticsEvent);
});
</script>

<style lang="scss" scoped>
@keyframes _grow {
  from {
    width: 0%;
    height: 0%;
  }
  to {
    width: 70%;
    height: 70%;
  }
}

.go_checkmark {
  height: 70%;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  animation-name: go_grow;
  animation-duration: 0.2s;
  animation-timing-function: ease-out;

  .go_check {
    margin-top: -5%;
    display: inline-block;
    transform: rotate(45deg);
    height: 50%;
    width: 20%;
    border-bottom: 10px solid;
    border-right: 10px solid;
    border-color: #fff;
  }
}
</style>
